// A text-player text headlines its first paragraph only when another follows it.
export function splitTitledText(
  text: string,
  hasTitle = true
): { title?: string; paragraphs: string[] } {
  const parts = text.split('\n\n');

  return hasTitle && parts.length > 1
    ? { title: parts[0], paragraphs: parts.slice(1) }
    : { paragraphs: parts };
}
